import { render } from "./Social-media.vue?vue&type=template&id=4f5339e5"
import script from "./Social-media.vue?vue&type=script&lang=js"
export * from "./Social-media.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src127270423/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__